import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { WISH_LIST_FETCH, WISH_LIST_SEND_STATUS } from "../actions/types";
import { wishListFetchSuccess } from "../actions/WishListActions";
import { authorizationHeader, getErrorMessage_v2 } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";
import { showErrorMessage } from "../actions/NotifyActions";
import { authSignOutSuccess } from "../actions/AuthActions";
axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
const wishListListFetchRequest = async (id) =>
  await axios
    .get(`${REACT_APP_API_URL}/client/v1/my-wish-lists`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const wishListFetchRequest = async (id) =>
  await axios
    .get(`${REACT_APP_API_URL}/client/v1/my-wish-list/${id}/`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

const wishListSendStatusRequest = async (payload) => {
  const inputData = {
    privilege_id: parseInt(payload.privilege_id),
    status: payload.status,
  };
  return await axios
    .post(`${REACT_APP_API_URL}/client/v1/my-wish-list`, inputData, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// WORKER

function* wishListFetchs({ payload }) {
  try {
    const data = yield call(wishListFetchRequest, payload);
    yield put(wishListFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* wishListSendStatus({ payload }) {
  try {
    yield call(wishListSendStatusRequest, payload);
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

// WATCHER

export function* wishListFetchWatcher() {
  yield takeEvery(WISH_LIST_FETCH, wishListFetchs);
}

export function* wishListSendStatusWatcher() {
  yield takeEvery(WISH_LIST_SEND_STATUS, wishListSendStatus);
}

export default function* rootSaga() {
  yield all([fork(wishListFetchWatcher), fork(wishListSendStatusWatcher)]);
}
